// The frame every page sits in (AA 00047 P8.1, spec FR-006b): a wallet-first header (the Night
// Market mark and name, the network, the sections, and the wallet on the right), and a short
// testnet footer. The footer links no About page (AA 00060 FR-029: the known limitations are in the
// README and the RUNBOOK). On a phone the sections move to a tab bar at the bottom of the screen.
//
//   <Masthead network={<span className="net-pill">Midnight stagenet</span>}
//             nav={<TabNav items={SECTIONS} current="markets" />}>
//     <ConnectButton />                         the wallet area (App.tsx)
//   </Masthead>
//   <SiteFooter networkName="Midnight stagenet" />

import type { ReactNode } from 'react';

import { Icon, LogoMark, type IconName } from './Icon.js';

export function Masthead({
  homeHref = '#markets',
  network,
  nav,
  children,
}: {
  homeHref?: string;
  /** The network pill, beside the name. */
  network?: ReactNode;
  /** The sections (a TabNav). */
  nav?: ReactNode;
  /** The wallet area, at the right. */
  children?: ReactNode;
}) {
  return (
    <header className="app-header">
      <div className="wrap app-header-inner">
        <div className="brand-block">
          <h1 className="brand">
            <a href={homeHref}>
              <LogoMark />
              <span className="brand-name">Night Market</span>
            </a>
          </h1>
          {network}
        </div>
        {nav}
        <div className="header-end">{children}</div>
      </div>
    </header>
  );
}

export interface TabItem {
  id: string;
  label: ReactNode;
  icon?: IconName;
}

export function TabNav({
  items,
  current,
  label = 'Sections',
}: {
  items: ReadonlyArray<TabItem>;
  current: string;
  label?: string;
}) {
  return (
    <nav className="nav" aria-label={label}>
      <ul>
        {items.map((t) => (
          <li key={t.id}>
            <a href={`#${t.id}`} aria-current={current === t.id ? 'page' : undefined} data-testid={`tab-${t.id}`}>
              {t.icon ? <Icon name={t.icon} className="nav-icon" /> : null}
              <span>{t.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

/** `bridging`: the site offers Bridge in (AA 00060 P7), so its wallet signs one kind of Solana transaction. */
export function SiteFooter({ networkName = 'Midnight stagenet', bridging = false }) {
  return (
    <footer className="site-foot">
      <div className="wrap">
        <p className="testnet" data-testid="testnet-notice">
          Testnet only — {networkName}. Tokens have no real value. A proof of concept.
        </p>
        {bridging ? (
          <p data-testid="footer-wallet-bridging">
            The tokens are Midnight test tokens from public faucets. Your Solana wallet signs messages for every market
            action; it signs a Solana transaction only when you bridge tokens in, after the page shows you what it does.
            Night Market never asks for your seed phrase or private key.
          </p>
        ) : (
          <p>
            The tokens are Midnight test tokens from public faucets. Your Solana wallet only signs messages: Night
            Market never sends a Solana transaction, and never asks for your seed phrase or private key.
          </p>
        )}
      </div>
    </footer>
  );
}
